/**
 * Skript slouží pro ajaxové zpracování formulářů
 *
 * Zapnutí se provádí importem souboru. Defaultně v takovém případe hledáme prvky s atributem
 * data-spinao-ajax="form"
 *
 * PŘÍKLAD:
 * import '../assets-base/assets-src/js/Spinao/NetteAjaxForm';
 *
 * V případě potřeby je možné soubor importovat do namespace a nastavit vlastní selector
 * pro identifikaci formulářů které mají být zpracovány ajaxem
 *
 * PŘÍKLAD:
 * import * as NetteAjaxForm '../assets-base/assets-src/js/Spinao/NetteAjaxForm';
 *
 * document.addEventListener("DOMContentLoaded", function() {
 *    NetteAjaxForm.initialize('.ajaxoveFormulare');
 * });
 */
import * as DOMHelpers from './DOMHelpers';
import * as NetteAjax from './NetteAjax';
import * as ReCaptcha from './GoogleReCaptcha';

const moduleName = 'NetteAjaxForm';

function prepareInputsValues(state) {
    let body = new FormData(state.formElement);

    return Object.assign({}, state, {
        body: body
    });
}

function prepareMethod(state) {
    return Object.assign({}, state, {
        method: state.formElement.getAttribute('method').toUpperCase()
    });
}

function prepareUrl(state) {
    return Object.assign({}, state, {
        url: state.formElement.getAttribute('action')
    });
}

function startSpinner(state) {
    let spinner = state.button.querySelector('[data-status="spinner"]');

    if(spinner) {
        spinner.classList.remove('d-none');
    }

    return Object.assign({}, state, {
        spinner: spinner ?? null
    });
}

function removeSpinner(state) {
    if(state.spinner) {
        state.spinner.classList.add('d-none')
    }

    return Object.assign({}, state, {
        spinner: state.spinner,
    });
}

function getSubmitButton(state) {
    let activeElement = document.activeElement;
    let activeIsButton = activeElement && activeElement.getAttribute('type') === 'submit';

    return Object.assign({}, state, {
        button: activeIsButton ? activeElement : state.formElement.querySelector('[type="submit"]')
    });
}

function processSubmit(form, event) {
    return NetteAjax.sendRequest(
        prepareInputsValues(
            prepareUrl(
                prepareMethod(
                    startSpinner(
                        getSubmitButton(
                            {formElement: form, event: event}
                        )
                    )
                )
            )
        )
    ).then(response => {
        console.log('test6', response);
        return removeSpinner(response);
    });
}

function initializeAjaxForm(formElement) {
    formElement.ajaxFormActive = true;
    formElement.addEventListener('submit', function(event) {
        console.log('888');
        event.preventDefault();
        formElement[moduleName].process(event);
    });

    return {
        process: function(event) {
            ReCaptcha.apply(formElement, function(){
                processSubmit(formElement, event);
            })
        }
    };
}

function factory(formElement) {
    if(formElement[moduleName] === undefined) {
        formElement[moduleName] = initializeAjaxForm(formElement);
    }
}

export function initialize(selector) {
    DOMHelpers.iterateQuerySelectorAll(document, selector, function(formElement) {
        factory(formElement);
    });
}

document.addEventListener("DOMContentLoaded", function() {
    initialize('[data-spinao-ajax="form"]')
});
